/** @format */

export default {
    // ===== Register | Account =====

    // A couple of translations that appear in different steps on the Register and Account page.
    '.tn-interests .control-label h3': {},
    '.tn-interests .checkbox label': {},
    // Items in the cart - memberships will be handled separately
    '.tn-cart-line-item-name:not([id^="tn-membership-description-"])': {},
    '.tn-cart-totals__label': {},
    // Production and package names
    '.tn-prod-list-item__property': {},

    // ===== Calendar =====

    // Filters above the calendar on the Events page.
    '#tn-events-keyword-filter li span': {},
};
